module.exports = __webpack_public_path__ + "img/31.fixed_blockage.26cdba10.svg";